"use strict";

module.exports = {
  FULFILLMENT_CONFIGURATIONS_BASE_URL: function FULFILLMENT_CONFIGURATIONS_BASE_URL(environment) {
    if (environment === 'int') {
      return 'https://int-api.fulfillmentconfigurations.cimpress.io';
    }

    return 'https://api.fulfillmentconfigurations.cimpress.io';
  },
  FULFILLMENT_CONFIGURATIONS_UI_URL: function FULFILLMENT_CONFIGURATIONS_UI_URL(environment) {
    if (environment === 'int') {
      return 'https://int.fulfillmentconfigurations.cimpress.io';
    }

    return 'https://fulfillmentconfigurations.cimpress.io';
  },
  FULFILLMENT_CONFIGURATION_ASSOCIATIONS_BASE_URL: function FULFILLMENT_CONFIGURATION_ASSOCIATIONS_BASE_URL(environment) {
    if (environment === 'int') {
      return 'https://stg.api.fcassociation.cimpress.io';
    }

    return 'https://api.fcassociation.cimpress.io';
  }
};